/**
 * resolveTenantBranding — 업로드 로고 우선, 없으면 정적 TENANT_BRANDING
 * colorMode 가 dark 이고 다크용 이미지가 있으면 그것을 쓴다.
 */
import { loadTenantLogo } from 'system/tenantLogoStore';

export const DEFAULT_LOGIN_TAGLINE = '전사적자원관리 토탈 솔루션';

/** @type {Record<string, { logoUrl: string, logoDarkUrl?: string, logoAlt: string, logoAreaDark?: boolean }>} */
export const TENANT_BRANDING = {
  GNK: {
    logoUrl: '/logos/gnk-ci.png',
    logoAlt: '굿네이버스',
    logoAreaDark: false,
  },
};

function withPublicUrl(url) {
  const base = process.env.PUBLIC_URL || '';
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${base}${path}`;
}

/**
 * @param {string} compCd
 * @param {'light'|'dark'} [colorMode]
 * @returns {{ logoUrl: string, logoAlt: string, logoAreaDark?: boolean, hasDarkLogo?: boolean, source?: 'upload'|'static' } | null}
 */
export function resolveTenantBranding(compCd, colorMode = 'light') {
  const code = String(compCd || '').trim().toUpperCase();
  if (!code) return null;
  const isDark = colorMode === 'dark';

  const uploaded = loadTenantLogo(code);
  if (uploaded?.logoDataUrl) {
    const useDarkLogo = isDark && !!uploaded.logoDarkDataUrl;
    return {
      logoUrl: useDarkLogo ? uploaded.logoDarkDataUrl : uploaded.logoDataUrl,
      logoAlt: uploaded.logoAlt || code,
      // 다크 로고를 쓰면 강제 다크 플레이트는 불필요
      logoAreaDark: useDarkLogo ? false : uploaded.logoAreaDark === true,
      hasDarkLogo: useDarkLogo,
      source: 'upload',
    };
  }

  const entry = TENANT_BRANDING[code];
  if (!entry?.logoUrl) return null;
  const useDarkLogo = isDark && !!entry.logoDarkUrl;
  return {
    ...entry,
    logoUrl: withPublicUrl(useDarkLogo ? entry.logoDarkUrl : entry.logoUrl),
    logoAreaDark: useDarkLogo ? false : entry.logoAreaDark,
    hasDarkLogo: useDarkLogo,
    source: 'static',
  };
}
